/**
 * MUI Select for RMA initial test results.
 *
 * Reads from the TestResult entity slice (pre-loaded by ProcessReturnForm's
 * useRmaReferenceData hook). Replicates the legacy sort: "Unknown" (id 59)
 * pinned to the top, rest sorted alphabetically.
 */

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { testResultSelector } from '@sophocles/entities/TestResult';

/** Pin the "Unknown" entry (id 59) to the top; sort the rest by name. */
function sortTestResults(immutableMap) {
  const list = immutableMap.toList();
  const unknownIdx = list.findIndex(e => e.get('id', 0) === 59);
  const unknown = unknownIdx === -1 ? null : list.get(unknownIdx);
  const rest = (unknownIdx === -1 ? list : list.delete(unknownIdx)).sortBy(e => e.get('name', ''));
  return unknown ? rest.unshift(unknown) : rest;
}

/**
 * @param {object} props
 * @param {number|string|null} props.value
 * @param {function} props.onChange  - (newValue) => void
 * @param {string} [props.label]
 */
export default function TestResultSelect({ value, onChange, label }) {
  const { t } = useTranslation();
  const raw = useSelector(testResultSelector);
  const options = sortTestResults(raw);
  const resolvedLabel = label ?? t('rma.initialTestResults', 'Initial Test Results');

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{resolvedLabel}</InputLabel>
      <Select value={value ?? ''} label={resolvedLabel} onChange={e => onChange(e.target.value || null)}>
        <MenuItem value="">
          <em>{t('rma.none', 'None')}</em>
        </MenuItem>
        {options.toArray().map(entry => (
          <MenuItem key={entry.get('id')} value={entry.get('id')}>
            {entry.get('name')}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
